const env:string = 'production';
const authUrl:string ='https://n25dgmao4d.execute-api.us-west-2.amazonaws.com/production/v1/apps/473d9aed-eaa2-405c-93a3-85c32f29419b/login';
const apiUrl:string = 'https://frostbite-recording-service-prod.atlas-services.ea.com';
const cloudFrontDomain: string = 'https://d3so2s59hittg5.cloudfront.net'

export {env, authUrl, apiUrl, cloudFrontDomain}